import { createPluginFactory, isCollapsed, ELEMENT_LINK } from '@udecode/plate';
import React from 'react';
import { Editor, Transforms, Node } from 'slate';
import styled from 'styled-components';

import isEditorEmpty from 'components/text_editor_new/lib/is_editor_empty';

export default function createLinkPlugin() {
  return createPluginFactory({
    key: ELEMENT_LINK,
    withOverrides: withLinks,

    isElement: true,
    isInline: true,

    component: StyledLinkInline,
  })();

  function withLinks(editor) {
    const { normalizeNode: unoverriddenNormalizeNode } = editor;

    editor.shouldDisableLinkButton = () => {
      const isEmpty = isEditorEmpty(editor);
      if (isEmpty) {
        return true;
      }

      const selection = editor.selection;
      return !selection || isCollapsed(selection);
    };

    editor.addLink = url => {
      if (editor && editor.selection) {
        const text = editor.selection ? Editor.string(editor, editor.selection) : '';
        Editor.withoutNormalizing(editor, () => {
          Transforms.delete(editor, { at: editor.selection });
          // This feels like it should be Transforms.insertNodes, but I found that Transforms.insertFragment produced the most consistent results
          Transforms.insertFragment(editor, [{ type: ELEMENT_LINK, url, children: [{ text }] }]);
        });
        const nodeEntry = editor.getCurrentLinkNode();
        if (nodeEntry && nodeEntry[1]) {
          Transforms.select(editor, nodeEntry[1]);
        }
      }
    };

    editor.getCurrentLinkNode = () => {
      const generator = Editor.nodes(editor, { match: n => n.type === ELEMENT_LINK });
      const { value: nodeEntry, done } = generator.next();
      return done ? null : nodeEntry;
    };

    editor.isLinkSelected = () => {
      return !!editor.getCurrentLinkNode();
    };

    editor.editLink = (node, url) => {
      Transforms.setNodes(editor, { url }, { at: node[1] });
    };

    editor.normalizeNode = ([node, path]) => {
      if (node?.type === ELEMENT_LINK) {
        const text = Node.string(node);

        if (!text) {
          Transforms.removeNodes(editor, { at: path });
        }
        // Updating the link's url to an empty string or clicking remove will remove the link node by setting the URL to ''
        else if (node.url === '') {
          Transforms.unwrapNodes(editor, { at: path });
        }
      }

      if (node?.type !== ELEMENT_LINK) {
        unoverriddenNormalizeNode([node, path]);
      }
    };

    return editor;
  }
}

const StyledLink = styled.a`
  cursor: pointer;
  color: ${p => p.theme.colors.green400};
  &:hover {
    color: ${p => p.theme.colors.green400};
    text-decoration: underline;
  }
`;

export const StyledLinkInline = props => {
  return <StyledLink href={props.element.url} title={props.element.url} {...props} />;
};
